import { readContract } from "../viem";
import config from "../../config/config";

import MafiaRaceXpAbi from "../../abis/MafiaRaceXP.json";

const address = config.raceXp;
const abi = MafiaRaceXpAbi;

export const getRaceXp = async (
  playerAddress: string,
  message: string,
  signature: string
) => {
  const raceXp = await readContract<string>({
    address,
    abi,
    functionName: "getXp",
    args: [playerAddress, JSON.stringify(message), signature],
  });

  return Number(raceXp);
};
